module.exports = __webpack_public_path__ + "img/8.b9e6f1a5.jpeg";